import { overrideConfig } from '@/components/widget/visualizations/internal/LineChart/utils';
import Label from '@/components/FormElements/Label';
import Select from '@/components/FormElements/Select';
import GeneralRevealPill from '@/components/Editor/Form/fields/GeneralRevealPill';
import { CHART_STYLE_ICONS } from './ChartStyle';
import parentStyles from '@/features/WidgetEdit/Form/styles.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const WidgetEditFormLineChartFields = _ref => {
  let {
    config,
    pillVariant,
    title,
    onChange,
    onChartSelect
  } = _ref;
  const {
    chartStyle = 'line'
  } = overrideConfig(config);
  const ChartStyleIconComponent = CHART_STYLE_ICONS[chartStyle];

  if (pillVariant !== 'compact') {
    return /*#__PURE__*/_jsx(Label, {
      className: parentStyles.formField,
      text: "Chart Style",
      children: /*#__PURE__*/_jsxs(Select, {
        defaultValue: chartStyle,
        onChange: evt => {
          var _evt$currentTarget;

          const value = ((_evt$currentTarget = evt.currentTarget) === null || _evt$currentTarget === void 0 ? void 0 : _evt$currentTarget.value) || '';
          onChange('', {
            chartStyle: value
          });
        },
        children: [/*#__PURE__*/_jsx("option", {
          value: "line",
          children: "Line"
        }), /*#__PURE__*/_jsx("option", {
          value: "area",
          children: "Area"
        }), /*#__PURE__*/_jsx("option", {
          value: "stackedArea",
          children: "Stacked Area"
        })]
      })
    });
  }

  return /*#__PURE__*/_jsx(GeneralRevealPill, {
    title: title ?? 'Line Chart',
    pillVariant: pillVariant,
    leftIcon: /*#__PURE__*/_jsx(ChartStyleIconComponent, {
      className: styles.icon
    }),
    onChartSelect: onChartSelect
  });
};

export default WidgetEditFormLineChartFields;